
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { LogOut } from "lucide-react";

interface SidebarUserProfileProps {
  userName: string;
  userRole: string;
  userAvatar?: string | null;
  onLogout: (e: React.MouseEvent) => Promise<void>;
}

const SidebarUserProfile = ({ 
  userName, 
  userRole, 
  userAvatar,
  onLogout 
}: SidebarUserProfileProps) => {
  // Creiamo le iniziali dal nome utente
  const initials = userName ? userName.charAt(0).toUpperCase() : '';
  
  console.log("SidebarUserProfile - userAvatar:", userAvatar); // Log per debug
  
  return (
    <div className="p-4 border-t bg-gray-50">
      <div className="flex items-center gap-3 mb-4">
        <Avatar className="h-10 w-10 border-2 border-white shadow-sm">
          <AvatarImage src={userAvatar || undefined} alt="Avatar utente" />
          <AvatarFallback className="bg-primary/10 text-primary text-sm">
            {initials}
          </AvatarFallback>
        </Avatar>
        <div>
          <p className="text-sm font-medium">{userName}</p>
          <p className="text-xs text-muted-foreground">{userRole}</p>
        </div>
      </div>
      
      <div className="flex flex-col gap-2">
        <button 
          className="flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors text-red-500 hover:text-red-700 hover:bg-red-50" 
          onClick={onLogout}
        >
          <LogOut size={18} />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default SidebarUserProfile;
